var _mask, _path, _path2, _path3, _circle, _path4, _line, _path5, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 24,
    viewBox: "0 0 102 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_243_3546",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 5C32.056 5 32.459 5 32.7982 5.03637C35.7845 5.35653 38.1435 7.71549 38.4636 10.7018C38.5 11.041 38.5 11.444 38.5 12.25C38.5 13.056 38.5 13.459 38.4636 13.7982C38.1435 16.7845 35.7845 19.1435 32.7982 19.4636C32.459 19.5 32.056 19.5 31.25 19.5L28.6564 19.5C27.7854 19.5 27.3498 19.5 27.0106 19.3461C26.6307 19.1737 26.3263 18.8693 26.1539 18.4894C26 18.1502 26 17.7146 26 16.8436L26 7.65644C26 6.78537 26 6.34983 26.1539 6.01064C26.3263 5.63072 26.6307 5.3263 27.0106 5.15391C27.3498 5 27.7854 5 28.6564 5L31.25 5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 5C32.056 5 32.459 5 32.7982 5.03637C35.7845 5.35653 38.1435 7.71549 38.4636 10.7018C38.5 11.041 38.5 11.444 38.5 12.25C38.5 13.056 38.5 13.459 38.4636 13.7982C38.1435 16.7845 35.7845 19.1435 32.7982 19.4636C32.459 19.5 32.056 19.5 31.25 19.5L28.6564 19.5C27.7854 19.5 27.3498 19.5 27.0106 19.3461C26.6307 19.1737 26.3263 18.8693 26.1539 18.4894C26 18.1502 26 17.7146 26 16.8436L26 7.65644C26 6.78537 26 6.34983 26.1539 6.01064C26.3263 5.63072 26.6307 5.3263 27.0106 5.15391C27.3498 5 27.7854 5 28.6564 5L31.25 5Z",
    stroke: "#141414",
    strokeWidth: 6.88924,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_243_3546)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5288 17.6982V12.1982C69.5288 9.16068 67.0664 6.69824 64.0288 6.69824V6.69824C60.9912 6.69824 58.5288 9.16068 58.5288 12.1982V17.6982",
    stroke: "#141414",
    strokeWidth: 3.44462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3958 6.73633L75.3958 12.2363C75.3958 15.2739 77.8582 17.7363 80.8958 17.7363V17.7363C83.9333 17.7363 86.3958 15.2739 86.3958 12.2363L86.3958 6.73633",
    stroke: "#141414",
    strokeWidth: 3.44462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3813,
    cy: 12.25,
    r: 5.52769,
    stroke: "#141414",
    strokeWidth: 3.44462
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6208 17.6982L98.3021 17.6982C94.7774 17.6982 91.92 14.8409 91.92 11.3161L91.92 6.69824",
    stroke: "#141414",
    strokeWidth: 3.44462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 93.3429,
    y1: 10.9418,
    x2: 97.8981,
    y2: 10.9418,
    stroke: "#141414",
    strokeWidth: 3.44462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20C10.3579 20 7 16.6421 7 12.5C7 8.35786 10.3579 5 14.5 5",
    stroke: "#141414",
    strokeWidth: 3.44462,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 2.5,
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.67e8b28735b8894fc2997eca4bfbaea6.svg";
export { ForwardRef as ReactComponent };